import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function DynamicTitle() {
    const location = useLocation();
    const [pageMeta, setPageMeta] = useState({
        title: 'Legal - Psicopatici.com',
        description: 'Welcome to Psicopatici Legal, your trusted partner in website management and optimization.',
        keywords: 'Huberway, Website Management, Digital Tools, Optimization',
        image: 'https://community.huberway.com/assets/images/home-image.png',
        url: 'https://community.huberway.com/',
    });

    useEffect(() => {
        const fetchArticleMeta = async (slug) => {
            try {
                const response = await fetch(`https://your-api-url.com/articles/${slug}`);
                const data = await response.json();

                setPageMeta({
                    title: `${data.title} - Psicopatici.com`,
                    description: data.description,
                    keywords: data.keywords,
                    image: data.image,
                    url: `https://speakers.huberway.com/article/${slug}`,
                });
            } catch (error) {
                console.error('Error fetching article meta:', error);
            }
        };

        const getPageMeta = (pathname) => {
            switch (pathname) {
                case '/':
                    return {
                        title: 'Legal - Psicopatici.com',
                        description: 'Welcome to Huberway Community, your trusted partner in website management and optimization.',
                        keywords: 'Huberway, Website Management, Digital Tools, Optimization',
                        image: 'https://community.huberway.com/assets/images/home-image.png',
                        url: 'https://community.huberway.com/',
                    };
                case '/privacy-policy':
                    return {
                        title: 'Privacy Policy - Psicopatici.com',
                        description: 'Explore our wide range of articles and resources on website management.',
                        keywords: 'Articles, Psicopatici, Resources, Website Management',
                        image: 'https://community.huberway.com/assets/images/home-image.png',
                        url: 'https://community.huberway.com/articles',
                    };
                case '/cookie-policy':
                    return {
                        title: 'Cookie Policy - Psicopatici.com',
                        description: 'Explore our wide range of articles and resources on website management.',
                        keywords: 'Articles, Psicopatici, Resources, Website Management',
                        image: 'https://community.huberway.com/assets/images/home-image.png',
                        url: 'https://community.huberway.com/articles',
                    };
                case '/terms-and-conditions':
                    return {
                        title: 'Termini & Condizioni - Psicopatici.com',
                        description: 'Explore our wide range of articles and resources on website management.',
                        keywords: 'Articles, Psicopatici, Resources, Website Management',
                        image: 'https://community.huberway.com/assets/images/home-image.png',
                        url: 'https://community.huberway.com/articles',
                    };
                default:
                    if (pathname.startsWith('/article/')) {
                        const slug = pathname.split('/article/')[1];
                        fetchArticleMeta(slug);
                        return pageMeta; // Temporary until the data is fetched
                    }
                    return {
                        title: '404 - Page Not Found',
                        description: 'The page you are looking for does not exist.',
                        keywords: '404, Page Not Found',
                        image: 'https://community.huberway.com/assets/images/home-image.png',
                        url: 'https://community.huberway.com/404',
                    };
            }
        };

        const meta = getPageMeta(location.pathname);
        if (!location.pathname.startsWith('/article/')) {
            setPageMeta(meta);
        }
    }, [location.pathname]);

    const { title, description, keywords, image, url } = pageMeta;

    return (
        <Helmet>
            {/* Meta tag di base */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="author" content="Huberway" />
            <meta name="robots" content="index, follow" />
            <link rel="canonical" href={url} />

            {/* Meta tag per i social network - Open Graph */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content="Huberway" />

            {/* Meta tag per Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:site" content="@Huberway" />

            {/* Meta tag di compatibilità e mobile */}
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        </Helmet>
    );
}

export default DynamicTitle;
